import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header, Footer } from "./components/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import { SettingsProvider } from "./lib/settings";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { MobileActionBar } from "./components/MobileActionBar";

function App() {
  return (
    <div className="App bg-background min-h-screen">
      <SettingsProvider>
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <FloatingWhatsApp />
          <MobileActionBar />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </SettingsProvider>
    </div>
  );
}

export default App;
